export const chains = [
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'akashnet-2',
    chainName: 'Akash',
    addressPrefix: 'akash',
    rpcURL: 'https://rpc.akashnet.net:443',
    restURL: 'https://api.akashnet.net',
    chainLogo: '/tokens/akt.svg',
    explorerURL: {
      transaction: 'https://www.mintscan.io/akash/tx/{transaction}',
    },
    channel: {
      source: 'channel-5',
      destination: 'channel-129',
    },
    currencies: [
      {
        coinDenom: 'AKT',
        coinMinimalDenom: 'uakt',
        coinDecimals: 6,
        coinGeckoId: 'akash-network',
        coinImageUrl: '/tokens/akt.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: true,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'axelar-dojo-1',
    chainName: 'Axelar',
    addressPrefix: 'axelar',
    rpcURL: 'https://axelar-rpc.publicnode.com:443',
    restURL: 'https://axelar-rest.publicnode.com',
    chainLogo: '/tokens/axelar.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/axelar-testnet/txs/{transaction}',
    },
    channel: {
      source: 'channel-3',
      destination: 'channel-163',
    },
    currencies: [
      {
        coinDenom: 'AXL',
        coinMinimalDenom: 'uaxl',
        coinDecimals: 6,
        coinGeckoId: 'axelar',
        coinImageUrl: '/tokens/axelar.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canDeposit: true,
        canWithdraw: true,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'celestia',
    chainName: 'Celestia',
    addressPrefix: 'celestia',
    rpcURL: 'https://celestia.rpc.stakin-nodes.com',
    restURL: 'celestia.rest.stakin-nodes.com',
    chainLogo: '/tokens/tia.svg',
    explorerURL: {
      transaction: 'https://celenium.io/tx/{transaction}',
    },
    channel: {
      source: 'channel-4',
      destination: 'channel-50',
    },
    currencies: [
      {
        coinDenom: 'TIA',
        coinMinimalDenom: 'utia',
        coinDecimals: 6,
        coinGeckoId: 'celestia',
        coinImageUrl: '/tokens/tia.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: true,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'cosmoshub-4',
    chainName: 'Cosmos Hub',
    addressPrefix: 'cosmos',
    rpcURL: 'https://cosmos-rpc.publicnode.com:443',
    restURL: 'https://cosmos-api.publicnode.com',
    chainLogo: '/tokens/atom.svg',
    explorerURL: {
      transaction: 'https://mintscan.io/cosmos/transactions/{transaction}',
    },
    channel: {
      source: 'channel-1',
      destination: 'channel-1266',
    },
    currencies: [
      {
        coinDenom: 'ATOM',
        coinMinimalDenom: 'uatom',
        coinDecimals: 6,
        coinGeckoId: 'cosmos',
        coinImageUrl: '/tokens/atom.svg',
        isFeeCurrency: true,
        isStakeCurrency: false,
        canSwap: false,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'elys-1',
    chainName: 'Elys Network',
    addressPrefix: 'elys',
    rpcURL: 'https://rpc.elys.network',
    restURL: 'https://api.elys.network',
    chainLogo: '/tokens/elys.svg',
    explorerURL: {
      transaction: 'https://elys.network/elys/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ELYS',
        coinMinimalDenom: 'uelys',
        coinDecimals: 6,
        coinGeckoId: 'elys-network',
        coinImageUrl: '/tokens/elys.svg',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: true,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.0003,
          average: 0.0025,
          high: 0.01,
        },
      },
      {
        coinDenom: 'EDEN BOOST',
        coinMinimalDenom: 'uedenb',
        coinDecimals: 6,
        coinGeckoId: 'uedenb',
        coinImageUrl: '/tokens/eden-boost.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'EDEN',
        coinMinimalDenom: 'ueden',
        coinDecimals: 6,
        coinGeckoId: 'ueden',
        coinImageUrl: '/tokens/eden.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'mainnet',
    chainId: 'noble-1',
    chainName: 'Noble',
    addressPrefix: 'noble',
    rpcURL: 'https://noble-rpc.polkachu.com:443',
    restURL: 'https://api.noble.xyz',
    chainLogo: '/tokens/noble.svg',
    explorerURL: {
      transaction: 'https://mintscan.io/noble/txs/{transaction}',
    },
    channel: {
      source: 'channel-2',
      destination: 'channel-117',
    },
    currencies: [
      {
        coinDenom: 'USDC',
        coinMinimalDenom: 'uusdc',
        coinDecimals: 6,
        coinImageUrl: '/tokens/usdc.svg',
        coinGeckoId: 'usd-coin',
        isFeeCurrency: true,
        canSwap: false,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'axelar-testnet-lisbon-3',
    chainName: 'Axelar (testnet)',
    addressPrefix: 'axelar',
    rpcURL: 'https://rpc-axelar-testnet.imperator.co',
    restURL: 'https://axelar-testnet-api.polkachu.com',
    chainLogo: '/tokens/axelar.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/axelar-testnet/txs/{transaction}',
    },
    channel: {
      source: 'channel-15',
      destination: 'channel-315',
    },
    currencies: [
      {
        coinDenom: 'AXL',
        coinMinimalDenom: 'uaxl',
        coinDecimals: 6,
        coinGeckoId: 'axelar',
        coinImageUrl: '/tokens/axelar.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'ETH',
        coinMinimalDenom: 'eth-wei',
        coinDecimals: 18,
        coinGeckoId: 'ethereum',
        coinImageUrl: '/tokens/eth.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'BNB',
        coinMinimalDenom: 'wbnb-wei',
        coinDecimals: 18,
        coinGeckoId: 'binancecoin',
        coinImageUrl: '/tokens/bnb.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'MATIC',
        coinMinimalDenom: 'wmatic-wei',
        coinDecimals: 18,
        coinGeckoId: 'matic-network',
        coinImageUrl: '/tokens/matic.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canWithdraw: false,
        canDeposit: false,
        canSwap: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'AVAX',
        coinMinimalDenom: 'wavax-wei',
        coinDecimals: 18,
        coinGeckoId: 'avalanche-2',
        coinImageUrl: '/tokens/avax.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canWithdraw: false,
        canDeposit: false,
        canSwap: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'blumbus_111-1',
    chainName: 'Dymension',
    addressPrefix: 'dym',
    rpcURL: 'https://dymension-rpc.publicnode.com:443',
    restURL: 'https://dymension-rest.publicnode.com',
    chainLogo: '/tokens/dym.svg',
    explorerURL: {
      transaction:
        'https://explorer.nodestake.org/dymension-testnet/tx/{transaction}',
    },
    channel: {
      source: 'channel-33',
      destination: 'channel-7',
    },
    currencies: [
      {
        coinDenom: 'DYM',
        coinMinimalDenom: 'adym',
        coinDecimals: 18,
        coinGeckoId: 'dymension',
        coinImageUrl: '/tokens/dym.svg',
        isNative: true,
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
    bip44: {
      coinType: 60,
    },
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'constantine-3',
    chainName: 'Archway (testnet)',
    addressPrefix: 'archway',
    rpcURL: 'https://rpc.constantine.archway.io:443',
    restURL: 'https://api.constantine.archway.io',
    chainLogo: '/tokens/archway.svg',
    explorerURL: {
      transaction: 'https://www.mintscan.io/archway-testnet/tx/{transaction}',
    },
    channel: {
      source: 'channel-25',
      destination: 'channel-184',
    },
    currencies: [
      {
        coinDenom: 'CONST',
        coinMinimalDenom: 'aconst',
        coinDecimals: 18,
        coinGeckoId: 'elys-network',
        coinImageUrl: '/tokens/archway.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'elgafar-1',
    chainName: 'Stargaze (testnet)',
    addressPrefix: 'stars',
    rpcURL: 'https://rpc.elgafar-1.stargaze-apis.com',
    restURL: 'https://rest.elgafar-1.stargaze-apis.com/',
    chainLogo: '/tokens/stargaze.svg',
    explorerURL: {
      transaction: 'https://testnet.ping.pub/stargaze/tx/{transaction}',
    },
    channel: {
      source: 'channel-27',
      destination: 'channel-849',
    },
    currencies: [
      {
        coinDenom: 'STARS',
        coinMinimalDenom: 'ustars',
        coinDecimals: 6,
        coinGeckoId: 'stargaze',
        coinImageUrl: '/tokens/stargaze.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'elysicstestnet-1',
    chainName: 'Elys Network (testnet)',
    addressPrefix: 'elys',
    rpcURL: 'https://rpc.testnet.elys.network',
    restURL: 'https://api.testnet.elys.network',
    chainLogo: '/tokens/elys.svg',
    explorerURL: {
      transaction: 'https://testnet.ping.pub/elys/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ELYS',
        coinMinimalDenom: 'uelys',
        coinDecimals: 6,
        coinGeckoId: 'elys-network',
        coinImageUrl: '/tokens/elys.svg',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: true,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: true,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.0003,
          average: 0.00035,
          high: 0.0004,
        },
      },
      {
        coinDenom: 'EDEN BOOST',
        coinMinimalDenom: 'uedenb',
        coinDecimals: 6,
        coinGeckoId: 'uedenb',
        coinImageUrl: '/tokens/eden-boost.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
      {
        coinDenom: 'EDEN',
        coinMinimalDenom: 'ueden',
        coinDecimals: 6,
        coinGeckoId: 'ueden',
        coinImageUrl: '/tokens/eden.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'evmos_9000-4',
    chainName: 'Evmos (testnet)',
    addressPrefix: 'evmos',
    rpcURL: 'https://rpc.testcosmos.directory/evmostestnet',
    restURL: 'https://rest.testcosmos.directory/evmostestnet',
    chainLogo: '/tokens/evmos.svg',
    explorerURL: {
      transaction: 'https://www.mintscan.io/evmos-testnet/tx/{transaction}',
    },
    channel: {
      source: 'channel-11',
      destination: 'channel-197',
    },
    currencies: [
      {
        coinDenom: 'TEVMOS',
        coinMinimalDenom: 'atevmos',
        coinDecimals: 18,
        coinGeckoId: 'evmos',
        coinImageUrl: '/tokens/evmos.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        bip44: {
          coinType: 60,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'grand-1',
    chainName: 'Noble (testnet)',
    addressPrefix: 'noble',
    rpcURL: 'https://noble-testnet-rpc.polkachu.com',
    restURL: 'https://api.testnet.noble.strange.love',
    chainLogo: '/tokens/noble.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/noble-testnet/txs/{transaction}',
    },
    channel: {
      source: 'channel-2',
      destination: 'channel-287',
    },
    currencies: [
      {
        coinDenom: 'STAKE',
        coinMinimalDenom: 'ustake',
        coinDecimals: 6,
        coinImageUrl: '/tokens/noble.svg',
        coinGeckoId: 'NONE',
        isStakeCurrency: true,
        isFeeCurrency: false,
        canWithdraw: false,
        canDeposit: false,
        canSwap: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'USDC',
        coinMinimalDenom: 'uusdc',
        coinDecimals: 6,
        coinImageUrl: '/tokens/usdc.svg',
        coinGeckoId: 'usd-coin',
        isFeeCurrency: true,
        canSwap: true,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'kava_2221-16000',
    chainName: 'Kava (testnet)',
    addressPrefix: 'kava',
    rpcURL: 'https://rpc.testnet.kava.io',
    restURL: 'https://api.testnet.kava.io',
    chainLogo: '/tokens/kava.svg',
    explorerURL: {
      transaction: 'https://www.mintscan.io/kava-testnet/tx/{transaction}',
    },
    channel: {
      source: 'channel-51',
      destination: 'channel-78',
    },
    currencies: [
      {
        coinDenom: 'KAVA',
        coinMinimalDenom: 'ukava',
        coinDecimals: 6,
        coinImageUrl: '/tokens/kava.svg',
        coinGeckoId: 'kava',
        isFeeCurrency: false,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        bip44: {
          coinType: 459,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'mocha-4',
    chainName: 'Celestia',
    addressPrefix: 'celestia',
    rpcURL: 'https://celestia-testnet-rpc.stake-town.com',
    restURL: 'https://api.celestia-mocha.com',
    chainLogo: '/tokens/tia.svg',
    explorerURL: {
      transaction:
        'https://explorer.modular.cloud/celestia-mocha/transactions/{transaction}',
    },
    channel: {
      source: 'channel-18',
      destination: 'channel-30',
    },
    currencies: [
      {
        coinDenom: 'TIA',
        coinMinimalDenom: 'utia',
        coinDecimals: 6,
        coinGeckoId: 'celestia',
        coinImageUrl: '/tokens/tia.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'osmo-test-5',
    chainName: 'Osmosis (testnet)',
    addressPrefix: 'osmo',
    rpcURL: 'https://osmosis-testnet-rpc.polkachu.com',
    restURL: 'https://lcd.osmotest5.osmosis.zone',
    chainLogo: '/tokens/osmo.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/osmosis-testnet/txs/{transaction}',
    },
    channel: {
      source: 'channel-17',
      destination: 'channel-4406',
    },
    currencies: [
      {
        coinDenom: 'OSMO',
        coinMinimalDenom: 'uosmo',
        coinDecimals: 6,
        coinGeckoId: 'osmosis',
        coinImageUrl: '/tokens/osmo.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.0025,
          average: 0.025,
          high: 0.04,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'provider',
    chainName: 'Cosmos Hub (testnet)',
    addressPrefix: 'cosmos',
    rpcURL: 'https://rpc.provider-sentry-01.ics-testnet.polypore.xyz',
    restURL: 'https://rest.provider-sentry-01.ics-testnet.polypore.xyz',
    chainLogo: '/tokens/atom.svg',
    explorerURL: {
      transaction: 'https://explorer.polypore.xyz/provider/tx/{transaction}',
    },
    channel: {
      source: 'channel-1',
      destination: 'channel-290',
    },
    currencies: [
      {
        coinDenom: 'ATOM',
        coinMinimalDenom: 'uatom',
        coinDecimals: 6,
        coinGeckoId: 'cosmos',
        exchangeData: 'Binance',
        coinImageUrl: '/tokens/atom.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: true,
        canDeposit: true,
        canWithdraw: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'sandbox-01',
    chainName: 'Akash Sandbox',
    addressPrefix: 'akash',
    rpcURL: 'https://rpc.sandbox-01.aksh.pw:443',
    restURL: 'https://api.sandbox-01.aksh.pw',
    chainLogo: '/tokens/akt.svg',
    explorerURL: {
      transaction: 'https://explorer.sandbox-01.aksh.pw/akash/tx/{transaction}',
    },
    channel: {
      source: 'channel-4',
      destination: 'channel-2',
    },
    currencies: [
      {
        coinDenom: 'AKT',
        coinMinimalDenom: 'uakt',
        coinDecimals: 6,
        coinGeckoId: 'akash-network',
        coinImageUrl: '/tokens/akt.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'stride-internal-1',
    chainName: 'Stride (testnet)',
    addressPrefix: 'stride',
    rpcURL: 'https://stride.testnet-1.stridenet.co',
    restURL: 'https://stride.testnet-1.stridenet.co/api',
    chainLogo: '/tokens/stride.svg',
    explorerURL: {
      transaction: 'https://testnet.ping.pub/stride/tx/{transaction}',
    },
    channel: {
      source: 'channel-48',
      destination: 'channel-39',
    },
    currencies: [
      {
        coinDenom: 'STRD',
        coinMinimalDenom: 'ustrd',
        coinDecimals: 6,
        coinGeckoId: 'stride',
        coinImageUrl: '/tokens/stride.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'test-core-2',
    chainName: 'Persistence (testnet)',
    addressPrefix: 'persistence',
    rpcURL: 'https://rpc.testcosmos.directory/persistencetestnet2',
    restURL: 'https://rest.testcosmos.directory/persistencetestnet2',
    chainLogo: '/tokens/persistence.svg',
    explorerURL: {
      transaction:
        'https://www.mintscan.io/persistence-testnet/tx/{transaction}',
    },
    channel: {
      source: 'channel-44',
      destination: 'channel-78',
    },
    currencies: [
      {
        coinDenom: 'XPRT',
        coinMinimalDenom: 'uxprt',
        coinDecimals: 6,
        coinGeckoId: 'persistence',
        coinImageUrl: '/tokens/persistence.svg',
        isStakeCurrency: false,
        isFeeCurrency: false,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'testnet',
    chainId: 'uni-6',
    chainName: 'Juno (testnet)',
    addressPrefix: 'juno',
    rpcURL: 'https://juno-testnet-rpc.polkachu.com',
    restURL: 'https://api.uni.junonetwork.io',
    chainLogo: '/tokens/juno.svg',
    explorerURL: {
      transaction: 'https://testnet.mintscan.io/juno-testnet/txs/{transaction}',
    },
    channel: {
      source: 'channel-10',
      destination: 'channel-641',
    },
    currencies: [
      {
        coinDenom: 'JUNOX',
        coinMinimalDenom: 'ujunox',
        coinDecimals: 6,
        coinGeckoId: 'juno-network',
        coinImageUrl: '/tokens/juno.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.0025,
          average: 0.0025,
          high: 0.004,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'devnet',
    chainId: 'elysdevnet-1',
    chainName: 'Elys Network (devnet)',
    addressPrefix: 'elys',
    rpcURL: 'https://rpc.devnet.elys.network',
    restURL: 'https://api.devnet.elys.network',
    chainLogo: '/tokens/elys.svg',
    explorerURL: {
      transaction:
        'https://explorer.nodestake.org/elys-devnet/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ELYS',
        coinMinimalDenom: 'uelys',
        coinDecimals: 6,
        coinGeckoId: 'elys-network',
        coinImageUrl: '/tokens/elys.svg',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: true,
        canDeposit: false,
        canWithdraw: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
      {
        coinDenom: 'EDEN BOOST',
        coinMinimalDenom: 'uedenb',
        coinDecimals: 6,
        coinGeckoId: 'uedenb',
        coinImageUrl: '/tokens/eden-boost.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
      {
        coinDenom: 'EDEN',
        coinMinimalDenom: 'ueden',
        coinDecimals: 6,
        coinGeckoId: 'ueden',
        coinImageUrl: '/tokens/eden.svg',
        isFeeCurrency: false,
        isStakeCurrency: true,
        canSwap: false,
        canDeposit: false,
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'devnet',
    chainId: 'grand-2',
    chainName: 'Noble (devnet)',
    addressPrefix: 'noble',
    rpcURL: 'https://noble-testnet-rpc.polkachu.com',
    restURL: 'https://api.testnet.noble.strange.love',
    chainLogo: '/tokens/noble.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/noble-testnet/txs/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'STAKE',
        coinMinimalDenom: 'ustake',
        coinDecimals: 6,
        coinImageUrl: '/tokens/noble.svg',
        coinGeckoId: 'NONE',
        isStakeCurrency: true,
        isFeeCurrency: false,
        canWithdraw: false,
        canDeposit: false,
        canSwap: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        coinDenom: 'USDC',
        coinMinimalDenom: 'uusdc',
        coinDecimals: 6,
        coinImageUrl: '/tokens/usdc.svg',
        coinGeckoId: 'usd-coin',
        isFeeCurrency: true,
        canSwap: true,
        canWithdraw: true,
        canDeposit: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
  {
    type: 'cosmos',
    chainNetwork: 'devnet',
    chainId: 'theta-devnet-001',
    chainName: 'Cosmos Hub (devnet)',
    addressPrefix: 'cosmos',
    rpcURL: 'https://rpc.sentry-02.theta-testnet.polypore.xyz',
    restURL: 'https://rest.sentry-02.theta-testnet.polypore.xyz',
    chainLogo: '/tokens/atom.svg',
    explorerURL: {
      transaction:
        'https://testnet.mintscan.io/cosmoshub-testnet/txs/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ATOM',
        coinMinimalDenom: 'uatom',
        coinDecimals: 6,
        coinGeckoId: 'cosmos',
        exchangeData: 'Binance',
        coinImageUrl: '/tokens/atom.svg',
        isStakeCurrency: true,
        isFeeCurrency: true,
        canSwap: true,
        canDeposit: true,
        canWithdraw: true,
        canUseLiquidityMining: true,
        canUseLeverageLP: true,
        canUsePerpetual: true,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03,
        },
      },
    ],
  },
] as const;
